import { Pipe, PipeTransform } from '@angular/core';
import { AlarmType } from 'app/models/alarm-type.enum';

@Pipe({
    name: 'AlarmTypePipe'
})
export class AlarmTypePipe implements PipeTransform {

    transform(value): any {
        switch (value) {
            case AlarmType.SHAKE:
                return Object.values(AlarmType)[AlarmType.SHAKE];
            case AlarmType.HEAT:
                return Object.values(AlarmType)[AlarmType.HEAT];
            case AlarmType.DISTANCE_CHANGE:
                return Object.values(AlarmType)[AlarmType.DISTANCE_CHANGE];             
            default:
                return Object.values(AlarmType)[AlarmType.NO_ALARM];
        }
    }
}
